import axios from 'axios';

export const subcategoryService = {
  async getSubcategories() {
    const response = await axios.get('https://api.elza2.store/api/v1/subcategories');
    return response.data;
  },

  async getSubcategoriesByCategory(categoryId) {
    const response = await axios.get(`https://api.elza2.store/api/v1/subcategories/${categoryId}`);
    return response.data;
  },

  async createSubcategory(subcategoryData) {
    const response = await axios.post('https://api.elza2.store/api/v1/subcategories', subcategoryData);
    return response.data;
  },

  async updateSubcategory(id, subcategoryData) {
    const response = await axios.put(`https://api.elza2.store/api/v1/subcategories/${id}`, subcategoryData);
    return response.data;
  },

  async deleteSubcategory(id) {
    await axios.delete(`https://api.elza2.store/api/v1/subcategories/${id}`);
  }
};